import {MutableRefObject, useEffect} from 'react';
import {sendEventToGA4} from 'app/helpers/gtagHelpers';
import {VideoJsPlayer} from 'video.js';
import Video from 'app/components/tv/models/video';
import Playlist from 'app/components/tv/models/Playlist';

const pushVideoTracking = (video: Video, videoIndex: number) => {
  sendEventToGA4('playlist_video_start', {
    video_provider: video.category,
    video_category: video.actionType,
    video_title: video.title,
    video_index: videoIndex,
    video_playlist: video.matchPlaylist,
  });
};

export default function useVideoStartTracking(
  playerRef: MutableRefObject<VideoJsPlayer | null>,
  video: Video | null,
  playerReady: boolean,
  playlist: Playlist | null
) {
  useEffect(() => {
    const player = playerRef.current;
    if (!player || !playerReady || !video || !playlist) {
      return;
    }

    const handleTimeupdate = () => {
      if (player.currentTime() <= 0) {
        return;
      }

      const currentVideoIndex = playlist.indexOf(video);
      pushVideoTracking(video, currentVideoIndex + 1);
      player.off('timeupdate', handleTimeupdate);
    };

    player.on('timeupdate', handleTimeupdate);
    return () => {
      if (player) {
        player.off('timeupdate', handleTimeupdate);
      }
    };
  }, [video, playerReady, playlist, playerRef]);
}
